import { useState, useEffect } from 'react';

const FlashMessage = (props) => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setIsVisible(false);
            console.log("habib")
        }, 5000); 
        

        return () => clearTimeout(timeout);
    }, []);

    return (
        <div className={`flash-message ${isVisible ? "visible" : "hidden"} ${props.success ? "success" : "failed"}`}>
            {props.message}
        </div>
    );
};

export default FlashMessage